import { Injectable } from '@angular/core';
import { MenuStore } from './menu.store';
import { Observable, tap, of, forkJoin, switchMap, catchError, EMPTY } from 'rxjs';
import { MainHeaderMenu, MegaMenuColumn, MenuStates, RouteData } from '../models';
import { MenuBuilderCollectionService } from './builders/menu-builder';
import { MegaMenuBuilderService } from './builders/mega-menu-builder';
import { VOID } from '@frontend-site/shared/utils';

export const RECENT_ITEMS_COUNT = 5;

@Injectable()
export class MenuService {
    get mainHeaderMenu$(): Observable<MainHeaderMenu> {
        return this.store.mainHeaderMenu$;
    }

    get megaMenuColumns$(): Observable<MegaMenuColumn[]> {
        return this.store.megaMenuColumns$;
    }

    constructor(
        private readonly menuBuilderCollectionService: MenuBuilderCollectionService,
        private readonly store: MenuStore,
        private readonly megaMenuBuilder: MegaMenuBuilderService
    ) {}

    loadMainMenu$(routeData: RouteData): Observable<void> {
        return forkJoin([this.loadMenu$(routeData), this.loadMegaMenu$()]).pipe(switchMap(() => VOID));
    }

    private loadMenu$(routeData: RouteData): Observable<MainHeaderMenu | null> {
        const menuState = routeData.data?.['menuState'] as MenuStates;
        if (!menuState) {
            return of(null);
        }

        return this.menuBuilderCollectionService
            .get(menuState)
            .build$(routeData)
            .pipe(
                tap((result) => {
                    if (result) {
                        this.store.setMainHeaderMenu(result);
                    }
                }),
                catchError((err) => {
                    console.error(err);
                    return EMPTY;
                })
            );
    }

    private loadMegaMenu$(): Observable<MegaMenuColumn[]> {
        return this.megaMenuBuilder.build$().pipe(
            tap((result) => {
                this.store.setMegaMenuColumns(result);
            })
        );
    }
}
